import { CircleAlert } from 'lucide-react';
import type { NodePath } from '@/components/tree-dnd/tree-dnd-types';
import { useTreeDndStore } from '@/components/tree-dnd/tree-dnd-store';
import { useI18nContext } from '@/i18n/i18n-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface TreeDndNegateButtonProps {
  path: NodePath;
  negated: boolean;
}

export function TreeDndNegateButton({
  path,
  negated,
}: TreeDndNegateButtonProps) {
  const { LL } = useI18nContext();
  const setNegated = useTreeDndStore((state) => state.setNegated);

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={cn(
        'size-7 shrink-0',
        negated
          ? 'text-destructive hover:text-destructive'
          : 'text-muted-foreground hover:text-foreground'
      )}
      aria-label={LL.audiences.filters.toggleNegation()}
      aria-pressed={negated}
      onClick={() => setNegated(path, !negated)}
      onPointerDown={(event) => event.stopPropagation()}
    >
      <CircleAlert className="size-4" strokeWidth={negated ? 2.75 : 2} />
    </Button>
  );
}
